import { legacyPlugins } from "/app/node_modules/.pnpm/@unhead+vue@3.4.1_@oxc-project+types@0.154.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_e47423638526267f8a0da03319b4f235/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}